var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CampaignSummaryModal',{ref:"campaignSummaryModal"}),_c('CampaignListTable',{attrs:{"filteredCampaigns":_vm.filteredCampaigns},on:{"viewSummary":_vm.viewSummary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }